import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.visible) = $event)),
    title: "编辑页",
    "show-close": false,
    width: "60%",
    center: "",
    "append-to-body": "",
    onOpen: _ctx.handleOpen
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.visible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleConfirm 
        }, {
          default: _withCtx(() => [
            _createTextVNode("提交")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-width": "150px",
        "label-position": "right",
        style: {"text-align":"left","width":"100%"},
        model: _ctx.formData,
        ref: "formRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "后端服务：",
            prop: "serviceName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.serviceName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.serviceName) = $event)),
                style: {"width":"100%"},
                filterable: "",
                clearable: "",
                remote: "",
                "reserve-keyword": "",
                placeholder: "请选择关联后端服务",
                onFocus: _ctx.handleSearchService,
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSelectServiceItem($event))),
                onClear: _ctx.handleClear
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.servicesList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.serviceName,
                      label: item.serviceName,
                      value: item.serviceName
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onFocus", "onClear"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "后端第一负责人:",
                    prop: "firstHeadOfBackend"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.firstHeadOfBackend,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.firstHeadOfBackend) = $event)),
                        placeholder: "关联后端服务后自动输入",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "后端备选负责人:",
                    prop: "secondHeadOfBackend"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.secondHeadOfBackend,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.secondHeadOfBackend) = $event)),
                        placeholder: "关联后端服务后自动输入",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "服务类型:",
            prop: "serviceType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.serviceType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.serviceType) = $event)),
                placeholder: "请选择服务类型",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.HANDLE_SERVICE_TYPE_LIST, (option) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: option.value,
                      label: option.label,
                      value: option.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "前端第一负责人:",
                    prop: "headOfDevelopment"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        type: "text",
                        style: {"width":"100%"},
                        remote: "",
                        filterable: "",
                        clearable: "",
                        modelValue: _ctx.formData.headOfDevelopment,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.headOfDevelopment) = $event)),
                        loading: _ctx.fuzzyLoading,
                        "remote-method": _ctx.fuzzyRemoteMethod,
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleChangeUser($event, _ctx.FIRST_PEOPLE_ENUM.DEVELOPMENT_FIRST)))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyResponse, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              value: item,
                              label: `${item.label}${item.bbCode}`,
                              key: item.value
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading", "remote-method"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "前端备选负责人:",
                    prop: "secondHeadOfDevelopment"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        type: "text",
                        style: {"width":"100%"},
                        remote: "",
                        filterable: "",
                        clearable: "",
                        modelValue: _ctx.formData.secondHeadOfDevelopment,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.secondHeadOfDevelopment) = $event)),
                        loading: _ctx.fuzzyLoading,
                        "remote-method": _ctx.fuzzyRemoteMethod,
                        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleChangeUser($event, _ctx.FIRST_PEOPLE_ENUM.DEVELOPMENT_SECOND)))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyResponse, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              value: item,
                              label: `${item.label}${item.bbCode}`,
                              key: item.value
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading", "remote-method"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "测试第一负责人:",
                    prop: "headOfTest"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        type: "text",
                        style: {"width":"100%"},
                        remote: "",
                        filterable: "",
                        clearable: "",
                        modelValue: _ctx.formData.headOfTest,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.headOfTest) = $event)),
                        loading: _ctx.fuzzyLoading,
                        "remote-method": _ctx.fuzzyRemoteMethod,
                        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleChangeUser($event,_ctx.FIRST_PEOPLE_ENUM.TEST_FIRST)))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyResponse, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              value: item,
                              label: `${item.label}${item.bbCode}`,
                              key: item.value
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading", "remote-method"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 12,
                prop: "NewSecondHeadOfTest"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "测试备选负责人:",
                    prop: "secondHeadOfTest"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        type: "text",
                        style: {"width":"100%"},
                        remote: "",
                        filterable: "",
                        clearable: "",
                        modelValue: _ctx.formData.secondHeadOfTest,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.secondHeadOfTest) = $event)),
                        loading: _ctx.fuzzyLoading,
                        "remote-method": _ctx.fuzzyRemoteMethod,
                        onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleChangeUser($event, _ctx.FIRST_PEOPLE_ENUM.TEST_SECOND)))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyResponse, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              value: item,
                              label: `${item.label}${item.bbCode}`,
                              key: item.value
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading", "remote-method"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue", "onOpen"]))
}